import { render, staticRenderFns } from "./ProjectStudentViewJournalsT.vue?vue&type=template&id=449bb764&scoped=true&"
import script from "./ProjectStudentViewJournalsT.vue?vue&type=script&lang=ts&"
export * from "./ProjectStudentViewJournalsT.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectStudentViewJournalsT.vue?vue&type=style&index=0&id=449bb764&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449bb764",
  null
  
)

export default component.exports